import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketingProductStepsComponent } from './marketing-product-steps.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [MarketingProductStepsComponent],
    imports: [CommonModule, RouterModule],
    exports: [MarketingProductStepsComponent],
})
export class MarketingProductStepsModule {}
